import { render, staticRenderFns } from "./HelpDocument.vue?vue&type=template&id=7685c2ac&scoped=true"
import script from "./HelpDocument.vue?vue&type=script&lang=js"
export * from "./HelpDocument.vue?vue&type=script&lang=js"
import style0 from "./HelpDocument.vue?vue&type=style&index=0&id=7685c2ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7685c2ac",
  null
  
)

export default component.exports